import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { QUIZ_QUESTIONS } from "@/lib/quiz";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString() : "-");

export const QuizFunnelCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/quiz-funnel").then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const pct = d.starts ? Math.round((d.finishes / d.starts) * 100) : 0;
  return (
    <div className="card-panel p-5" data-testid="quiz-funnel-card">
      <div className="eyebrow text-[#FD0F10]">QUIZ FUNNEL · LAST {d.days} DAYS</div>
      <div className="mt-3 flex gap-6 text-sm">
        <div><div className="text-gray-500 text-xs">STARTS</div><div className="text-white text-xl font-bold" data-testid="quiz-funnel-starts">{d.starts}</div></div>
        <div><div className="text-gray-500 text-xs">FINISHES</div><div className="text-white text-xl font-bold" data-testid="quiz-funnel-finishes">{d.finishes}</div></div>
        <div><div className="text-gray-500 text-xs">FINISH RATE</div><div className="text-white text-xl font-bold">{pct}%</div></div>
      </div>
      <div className="mt-4 text-xs text-gray-400">Where people quit (last question they reached):</div>
      <ul className="mt-2 space-y-1 text-xs" data-testid="quiz-funnel-quits">
        {d.quit_at.length === 0 && <li className="text-gray-500">No drop-offs recorded yet.</li>}
        {d.quit_at.map(q => (
          <li key={q.step} className="flex justify-between gap-3 border-t border-[#2A2E39] pt-1" data-testid={`quiz-quit-${q.step}`}>
            <span className="text-gray-300">Q{q.step + 1}. {QUIZ_QUESTIONS[q.step]?.title || ""}</span>
            <span className="text-white font-bold">{q.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const RealUsersCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/real-users").then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="card-panel p-5" data-testid="real-users-card">
      <div className="eyebrow text-[#FD0F10]">REAL USERS ({d.count})</div>
      <p className="text-xs text-gray-500 mt-1">Owner, tester and test accounts are hidden. Only you can see this.</p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full min-w-[760px] text-xs" data-testid="real-users-table">
          <thead className="text-gray-500 font-mono-ui uppercase">
            <tr><th className="text-left py-1 pr-2">User</th><th className="px-2">Signed up</th><th className="px-2 text-left">Path</th><th className="px-2">Milestone</th><th className="px-2">Sprint days</th><th className="px-2">Coach msgs</th><th className="pl-2">Last active</th></tr>
          </thead>
          <tbody>
            {d.users.map((u, i) => (
              <tr key={`${u.email}-${i}`} className="border-t border-[#2A2E39] text-gray-300" data-testid={`real-user-row-${i}`}>
                <td className="py-1.5 pr-2 min-w-[200px] break-words">{u.name ? `${u.name} · ` : ""}{u.email}</td>
                <td className="px-2 text-center">{fmt(u.signup)}</td>
                <td className="px-2">{u.path || "-"}</td>
                <td className="px-2 text-center">{u.milestone || "-"}</td>
                <td className="px-2 text-center">{u.sprint_days}/7</td>
                <td className="px-2 text-center">{u.coach_messages}</td>
                <td className="pl-2 text-center">{fmt(u.last_active)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {d.users.length === 0 && <p className="text-xs text-gray-500 mt-2">No real users yet.</p>}
      </div>
    </div>
  );
};
